import { createReducer, on } from '@ngrx/store';
import { TableFilterResult } from '@shared/models/table-filter.model';
import * as CatalogActions from '../actions/catalog.actions';
import { OrderByPropertyOfCatalogOrderByEnumRequestDto } from '@core/services/apiclient';

export const catalogFeatureKey = 'catalog';

export interface State {
  filters: TableFilterResult[];
  orderBy: OrderByPropertyOfCatalogOrderByEnumRequestDto | null;
  pastEvents: boolean;
}

export const initialState: State = {
  filters: [],
  orderBy: null,
  pastEvents: false,
};

export const reducer = createReducer(
  initialState,
  on(CatalogActions.setCatalogListFilters, (state, { filters }) => ({
    ...state,
    filters,
  })),
  on(CatalogActions.resetCatalogListState, () => (initialState)),
  on(CatalogActions.setEventsListOrderBy, (state, { orderBy }) => ({ ...state, orderBy })),
  on(CatalogActions.setPassedToggle, (state, { pastEvents }) => ({ ...state, pastEvents })),
);
